import * as React from 'react';

export class ClickAwayListener extends React.Component {
    ref = React.createRef();

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.ref && !this.ref.current.contains(event.target)) {
            this.props.onClickAway();
        }
    }

    render() {
        const { onClickAway, ...restProps } = this.props;

        return <div ref={this.ref} {...restProps} />;
    }
}